import React from 'react';
import { Col, Row } from 'reactstrap';
import { H5 } from '../../AbstractElements';
import { FeaturedTutorials } from '../../Constant';
import { FeaturedData } from '../../Data/FAQ/FeaturedData';
import FeaturesTutorial from '../Knowledgebase/KnowledgeBase/FeaturesTutorial';

const FAQFeaturesTutorial = () => {
  return (
    <Col lg='12' className='featured-tutorial'>
      <div className='header-faq'>
        <H5 className='mb-0'>{FeaturedTutorials}</H5>
      </div>
      <Row>
        <FeaturesTutorial FeaturedData={FeaturedData} />
      </Row>
    </Col>
  );
};
export default FAQFeaturesTutorial;
